export const data = {
  hindi: [
    'Umdaa',
    'Behtareen',
    'Mast',
    'Gazab',
    'Theek',
    'Ghatiya',
    'Bekaar',
    'Bura',
    'Waah',
    'Sahi',
    'Bhaukaal',
    'Chalega',
    'Ajeeb',
    'Maza aa Gaya',
    'Kuch bhi',
    'Khatarnaak',
    'Zabardast',
    'Bawaal',
    'Garda',
    'Dhaansu',
    'Tabadtod',
    'Ek number',
    'Tagda',
    'Rapchik',
    'Jhakkas',
  ],
  expl_hindi: [
    'Chutiya',
    'Gaand Faad',
    'Bakchod',
    'Lund',
    'Lawda Mera',
    'Tatti',
    'Antshant',
  ],
  expl_bengali: ['Baaler', 'Jhanter', 'Bokachoda'],
  bengali: [
    'Bhalo',
    'Khub Bhalo',
    'Besh',
    'Cholbe',
    'Theek Ache',
    'Khaarap',
    'Faltoo',
    'Darun',
    'Osadharon',
    'Opurbo',
    'Baje',
    'Byapok',
    'Aldai',
    'Fatafaati',
    'Motomoti',
    'Chorom',
  ],
  tamil: [
    'Semma',
    'Piliral',
    'Sorgam',
    'Karumam',
    'Komattal',
    'Mosam',
    'Super',
    'Merattal',
    'Pinnitanga',
    'Mass',
    'Takkar',
    'Mokka',
    'Kandravi',
    'Blade',
    'Padu Mokka',
    'Karmom',
    'Kevalam',
    'Thaaru Maaru',
    'Sirappu',
  ],
  malayalam: [
    'Adipoli',
    'Kidu',
    'Kuthara',
    'Mosham',
    'Bhayankaram',
    'Poli',
    'Kemam',
    'Thakarppan',
    'Kollam',
    'Cheelu',
    'Thallipoli',
    'Thattikkoottu',
    'Thara',
    'Aakri',
    'kolloolla',
  ],
};
